<template>
  <div class="toast warning-toast">
    <span class="message">{{ message }}</span>
  </div>
</template>

<script setup>
import { defineProps, onMounted } from "vue";
const props = defineProps({ message: String });

onMounted(() => {
  setTimeout(() => {
    const el = document.querySelector(".warning-toast");
    if (el) el.remove();
  }, 4000);
});
</script>

<style scoped>
.toast {
  position: fixed;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  background: #f0ad4e;
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  font-family: "Eastman-Regular", sans-serif;
  font-size: 14px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 9999;
  animation: fadeInUp 0.3s ease;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate(-50%, 50px);
  }
  to {
    opacity: 1;
    transform: translate(-50%, 0);
  }
}
</style>